/*
Akhilaavvaru 09/30/2022 2698821717 added filed function in add client and dashboard
saikrishna 10/03/2022 2698821717 Feature: Added three fields in multiple places wherever required in client management
saikrishna 10/03/2022 2698821717 bugfix: fixed disable button bug in client maintenance
saikrishna 10/04/2022 2698821717 bugFix: fixexed bugs in column names
saikrishna 10/06/2022 2698821717 Removed unecesarry console.log statements
saikrishna 10/07/2022 2698821717 fixed expiry bug change password
Suresh Peddavoora 10/30/2022 2698821717  Added outlined icons in Actions Column in table
saikrishna 11/15/2022 2698821717 Fixed active rate background color
Ashraf 11/15/2022 2698821717 Added Tooltips to icons
Raghhu 11/16/2022 2698821717 Icon spacing fixes in table

*/
import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import HistoryIcon from '@material-ui/icons/History';
import DialogBox from '../../../components/DialogBox';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  Accordion,
  AccordionDetails,
  IconButton,
  makeStyles,
  Tooltip,
  Typography,
  withStyles,
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import moment from 'moment';
import HistoryDialog from './HistoryDialog';
import {
  deleteRate,
  fetchRateHistoryData,
  fetchSubscribedAndInactiveServices,
  fetchUnsubscribedServices,
  resetDateValidation,
  resetStatusCode,
  startDateValidationApi,
  resetHistoryData,
} from '../../../redux/reducers/ClientRateHistory';
import EditSubServiceTypeDialog from './EditSubServiceTypeDialogcp';
import PageLoader from '../../../components/PageLoader';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import SubscribeServicePopup from './SubscribeServicePopup';
import {resetMessage} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import MouseOverPopover from '../../../components/MousePopOver/MousePopOver';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
const useStyles = makeStyles((theme) => ({
  link: {
    color: '#320469 !important',
  },
  root: {
    '& .MuiAccordionSummary-root.Mui-expanded': {
      height: 15,
      minHeight: '40px',
    },
  },
}));


// Detail panel(Accordian) for Client maintenance main table Client row
function DetailPanel({rowData, advancedSearchData}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [editSubServiceDialog, setEditSubServiceDialog] = useState(false);
  const [historyDialog, setHistoryDialog] = useState(false);
  const [rowDataHistory, setRowDataHistory] = useState([]);
  const [prePopData, setPrePopData] = useState({});
  const [rowData1, setRowData1] = useState(rowData);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [clientRatecardId, setclientRatecardId] = useState('');
  const [unsubscribeRowData, setUnsubscribeRowData] = useState({});
  const [futureEffeciveValidationArr, setFutureEffeciveValidationArr] = useState([]);


  const {errorMsg, successMsg} = useSelector(({clientGeneral}) => clientGeneral);

  // Redux data fetched for client row subsctibed and inactive API triggers
  const {successMsg2, isLoading, unsubScribedData, subscribedAndInactiveData, errorMsg2} = useSelector(
    ({clientRateHistory}) => ({
      successMsg2: clientRateHistory.successMsg,
      unsubScribedData: clientRateHistory.unsubScribedData,
      isLoading: clientRateHistory.isLoading,
      subscribedAndInactiveData: clientRateHistory.subscribedAndInactiveData,
      errorMsg2: clientRateHistory.errorMsg,
    }),
  );

  const {roleData} = useSelector(({role}) => role);
  // const [parentRowData, setParentRowData] = useState(rowData);
  const parentRowData = rowData;
  const AccordionSummary = withStyles({
    root: {
      'backgroundColor': 'rgba(0, 0, 0, .03)',
      'borderBottom': '1px solid rgba(0, 0, 0, .125)',
      'marginBottom': -1,
      'flexDirection': 'row-reverse',
      'height': 15,
      '&$expanded': {
        height: '15px !important',
        minHeight: '30px !important',
      },
      '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
        transform: 'rotate(90deg)',
        padding: '0px',
        marginRight: '10px',
        marginBottom: '0px',
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        marginTop: '0px',
        marginBottom: '0px',
        minHeight: '30px !important',
      },
      '& .MuiAccordionSummary-content': {
        height: 13,
        alignItems: 'center',
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        height: 14,
      },
      'content': {
        '&$expanded': {
          margin: '0px 0',
          height: 16,
        },
      },
    },
  })(MuiAccordionSummary);


  const getDisableEditSubscribe = (subService) => {
    const futureDisableObject = {};
    const reqArrForDisableEdit = [];

    subscribedAndInactiveData?.subscribeServiceResponses?.forEach((each) => {
      each?.subServiceTypeListResponses &&
        each?.subServiceTypeListResponses.map((each2) => {
          if (subService?.companyType === each2?.companyType && subService?.serviceType === each2?.serviceType && subService?.subServiceType === each2?.subServiceType ) {
            reqArrForDisableEdit.push(each2);
          }
        });
    });
    reqArrForDisableEdit &&
    reqArrForDisableEdit.length > 0 &&
    reqArrForDisableEdit.forEach((each) => {
      futureDisableObject[each?.clientNumber] = [each];
    });

    if (Object.keys(futureDisableObject).includes(subService?.clientNumber)) {
      if (
        futureDisableObject[subService?.clientNumber][0]?.serviceStartDt ===
          subService?.serviceStartDt &&
        futureDisableObject[subService?.clientNumber][0]?.serviceEndDt === subService?.serviceEndDt
      ) {
        return false;
      }
      return true;
    }
    return true;
  };


  useEffect(() => {
    unsubscribeCall();
  }, [subscribedAndInactiveData]);


  const handleEditRow = (data, service) => {
    const payLoadStartDateValidaion = {
      clientNumber: data?.clientNumber,
      subServiceType: data?.subServiceType,
    };
    dispatch(startDateValidationApi(payLoadStartDateValidaion));

    const reqArr = [];
    subscribedAndInactiveData?.subscribeServiceResponses?.forEach((each) => {
      each?.subServiceTypeListResponses &&
        each?.subServiceTypeListResponses.map((each2) => {
          if (data?.companyType === each2?.companyType && data?.serviceType === each2?.serviceType && data?.subServiceType === each2?.subServiceType ) {
            reqArr.push(each2);
          }
        });
    });
    setFutureEffeciveValidationArr(reqArr);

    let row;
    if (service === 'subscribed') {
      row = {...data, subscribedService: true};
    } else {
      row = {...data, subscribedService: false};
    }
    setRowData1(row);
    // if (data.isCurrentRate) {
    setEditSubServiceDialog(true);
    // } else {
    // setEditSubServiceDialogFuture(true);
    setPrePopData(data);
    // }
  };
  const handleHistory = (data, service) => {
    const details = {
      clientId: data.clientNumber,
      subServiceType: data.subServiceType,
    };
    dispatch(fetchRateHistoryData(details));
    setRowDataHistory(data.subServiceTypeHistory);
    setHistoryDialog(true);
  };

  const handleSubscribePopup = () => {
    setShowSubscribePopup(false);
  };

  const handleSubServiceDialog = () => {
    setEditSubServiceDialog(false);
    dispatch(resetDateValidation());
  };

  const handleHistoryDialog = () => {
    setHistoryDialog(false);
    setTimeout(() => {
      dispatch(resetHistoryData());
    }, 500);
  };
  const unsubscribeCall = () => {
    let payLoad = {
      clientNumber: [],
    };
    subscribedAndInactiveData?.subscribeServiceResponses?.forEach((each) => {
      each?.subServiceTypeListResponses &&
        each?.subServiceTypeListResponses.map((each2) => {
          payLoad.clientNumber.push(each2.clientNumber);
        });
    });
    subscribedAndInactiveData?.inActiveSubscribedServices?.forEach((each) => {
      each?.subServiceTypeListResponses &&
        each?.subServiceTypeListResponses.map((each2) => {
          payLoad.clientNumber.push(each2.clientNumber);
        });
    });
    dispatch(fetchUnsubscribedServices(payLoad));
    payLoad = {};
  };
  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        let payLoad1 = {
          clientName: rowData.clientName,
          parentClientName: rowData.parentClientName,
        };
        dispatch(fetchSubscribedAndInactiveServices(payLoad1));
        payLoad1 = {};
        dispatch(resetMessage());
      }, 2500);
    } else if (successMsg2) {
      setTimeout(() => {
        let payLoad1 = {
          clientName: rowData.clientName,
          parentClientName: rowData.parentClientName,
        };
        dispatch(fetchSubscribedAndInactiveServices(payLoad1));
        payLoad1 = {};
        dispatch(resetStatusCode());
      }, 2500);
    }
  }, [successMsg, successMsg2]);

  useEffect(() => {
    let payLoad1 = {
      clientName: rowData.clientName,
      parentClientName: rowData.parentClientName,
    };
    dispatch(fetchSubscribedAndInactiveServices(payLoad1));
    payLoad1 = {};
  }, []);

  const handleDelete = (rateData) => {
    setIsDelete(true);
    setclientRatecardId(rateData?.clientRatecardId);
  };

  const handleDeleteSubmit = () => {
    dispatch(deleteRate(clientRatecardId));
    setIsDelete(false);
  };

  const handleCloseDialogDelete = () => {
    setIsDelete(false);
  };
  const getfeeValue = (value, feeType) => {
    if (feeType.includes('per')) {
      return value + ' %';
    } else {
      return '$ ' + value;
    }
  };

  const subscribedAccordian = () => {
    return (
      <Accordion
        className={`justify-content-center ${classes.root}`}
        onChange={(e, expanded) => {
          if (expanded) {
          }
        }}
      >
        <AccordionSummary
          expandIcon={<ChevronRight className="mr-2" />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{maxHeight: '30px !important'}}
        >
          <Typography style={{fontWeight: 'bold'}}>Subscribed services</Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{display: 'inherit', overflow: 'hidden'}}
          className={`mui-custom-table-container  p-0`}
        >
          {subscribedAndInactiveData?.subscribeServiceResponses &&
            subscribedAndInactiveData?.subscribeServiceResponses?.length > 0 ? (
              subscribedAndInactiveData?.subscribeServiceResponses.map((each, index) => {
                return (
                  <Accordion
                    key={index}
                    style={{width: '100%', marginTop: '0px'}}
                    className="custom-window-accordion "
                  >
                    <AccordionSummary
                      expandIcon={<ChevronRight className="mr-2" />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography style={{fontWeight: 'bold'}}>{each?.companyType}</Typography>
                    </AccordionSummary>

                    <AccordionDetails className="p-0" style={{overflow: 'hidden'}}>
                      <table style={{width: '100%'}}>
                        <thead className="recFormat-header-container" style={{width: '100%'}}>
                          <tr>
                            <th style={{textAlign: 'center'}}>Actions</th>
                            <th style={{textAlign: 'left'}}>Client Code</th>
                            <th style={{textAlign: 'left'}}>Service Type</th>
                            <th>
                              <div
                                style={{textAlign: 'left', maxWidth: '200px', wordWrap: 'normal'}}
                              >
                              Sub Service Type
                              </div>
                            </th>
                            <th style={{textAlign: 'left'}}>Rate Type</th>
                            <th style={{textAlign: 'right'}}>Value</th>
                            <th style={{textAlign: 'left'}}>Start Date</th>
                            <th style={{textAlign: 'left'}}>End Date</th>
                            <th style={{textAlign: 'left'}}>Debtor Over Payments Remitted</th>
                            <th style={{textAlign: 'left'}}>Inflation Agreement</th>
                            <th style={{textAlign: 'left'}}>Postage Agreement</th>
                            <th style={{textAlign: 'left'}}>Rate Notes</th>
                          </tr>
                        </thead>
                        {each?.subServiceTypeListResponses &&
                        each?.subServiceTypeListResponses.length > 0 &&
                        each?.subServiceTypeListResponses.map((subService) => {
                          return (
                            <tbody key={subService} className="recFormat-body" style={{width: '100%'}}>
                              <tr
                                id={subService?.isCurrentRate ? 'active-rate' : ''}
                                // style={{
                                //   backgroundColor: subService?.isCurrentRate ? "#90ee90 !important" : "",
                                // }}
                              >
                                <td>
                                  <div className="d-flex flex-row justify-content-start align-items-center">
                                    {!getDisableEditSubscribe(subService) && <IconButton
                                      style={{
                                        opacity: !roleData?.window?.['Client Maintenance']?.CG
                                          ?.edit ?
                                          0.3 :
                                          1,
                                      }}
                                      disabled={
                                        !roleData?.window?.['Client Maintenance']?.CG?.edit
                                      }
                                      onClick={() => {
                                        roleData?.window?.['Client Maintenance']?.CG?.edit &&
                                          handleEditRow(subService, 'subscribed');
                                      }}
                                      className="client-search-icons"
                                    >
                                      <Tooltip title="Edit"><EditOutlinedIcon /></Tooltip>
                                    </IconButton>}
                                    <Tooltip title="History"><HistoryIcon
                                      onClick={() => handleHistory(subService)}
                                      className="client-search-icons mx-2"
                                    /></Tooltip>
                                    {!subService?.isCurrentRate && !getDisableEditSubscribe(subService) && (
                                      <Tooltip title="Delete"><DeleteOutlineOutlinedIcon
                                        style={{
                                          opacity: !roleData?.window?.['Client Maintenance']?.CG
                                            ?.delete ?
                                            0.3 :
                                            1,
                                        }}
                                        disabled={
                                          !roleData?.window?.['Client Maintenance']?.CG?.delete
                                        }
                                        className="client-search-icons mx-2"
                                        onClick={() => {
                                          if (roleData?.window?.['Client Maintenance']?.CG
                                            ?.delete) {
                                            handleDelete(subService);
                                          }
                                        }}
                                      /></Tooltip>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <Link
                                    to={{
                                      pathname: `/client-maintenance`,
                                      state: {
                                        clientNumber: subService?.clientNumber ?
                                          subService?.clientNumber :
                                          '',
                                      },
                                    }}
                                    className={classes.link}
                                  >
                                    {subService?.clientNumber}
                                  </Link>
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.serviceType}
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.subServiceType}
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {subService?.feeType[0].toUpperCase() +
                                    subService?.feeType.substring(1) === 'Flat' ? 'Flat Fee ' : subService?.feeType[0].toUpperCase() +
                                    subService?.feeType.substring(1)}
                                </td>
                                <td style={{textAlign: 'right'}}>
                                  {getfeeValue(
                                    subService?.feeValue.toFixed(2),
                                    subService?.feeType,
                                  )}
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {
                                    <div>
                                      {subService?.serviceStartDt !== null ?
                                        moment(subService.serviceStartDt).format('MM/DD/YYYY') :
                                        ''}
                                    </div>
                                  }
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {
                                    <div>
                                      {subService?.serviceEndDt !== null ?
                                        moment(subService.serviceEndDt).format('MM/DD/YYYY') :
                                        ''}
                                    </div>
                                  }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.paymentsRemitted ? subService?.paymentsRemitted === 'send' ? 'Send' : 'Don\'t Send' : '' }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.inflationAgreement ? subService?.inflationAgreement : '' }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.postageAgreement ? subService?.postageAgreement : '' }
                                </td>
                                <td
                                  style={{
                                    textAlign: 'left',
                                    maxWidth: '150px',
                                    overflowWrap: 'break-word',
                                  }}
                                >
                                  {subService?.rateNotes ? <MouseOverPopover
                                    data={subService?.rateNotes}
                                    popOverData={subService?.rateNotes}
                                    codeLength={subService?.rateNotes?.length}
                                  /> : '-'}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Typography className="text-center font-weight-bold mt-1 p-2">
              No records to display
              </Typography>
            )}
        </AccordionDetails>
      </Accordion>
    );
  };

  const unsubscribedAccordian = () => {
    return (
      <Accordion
        className={`justify-content-center ${classes.root}`}
        onChange={(e, expanded) => {
          if (expanded) {
            unsubscribeCall();
          }
        }}
      >
        <AccordionSummary
          expandIcon={<ChevronRight className="mr-2" />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{maxHeight: '30px !important'}}
        >
          <Typography style={{fontWeight: 'bold'}}>Unsubscribed services</Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{display: 'inherit', overflow: 'hidden'}}
          className={`mui-custom-table-container  p-0`}
        >
          {unsubScribedData &&
            unsubScribedData?.length > 0 &&
            unsubScribedData.map((each, index) => {
              return (
                <Accordion
                  key={index}
                  style={{width: '100%', marginTop: '0px'}}
                  className="custom-window-accordion "
                >
                  <AccordionSummary
                    expandIcon={<ChevronRight className="mr-2" />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography style={{fontWeight: 'bold'}}>{each?.companyType}</Typography>
                  </AccordionSummary>

                  <AccordionDetails className="p-0" style={{overflow: 'hidden'}}>
                    <table style={{width: '100%'}}>
                      <thead className="recFormat-header-container" style={{width: '100%'}}>
                        <tr>
                          <th style={{textAlign: 'center'}}>Actions</th>
                          <th style={{textAlign: 'left'}}>Service Type</th>
                          <th>
                            <div style={{textAlign: 'left'}}>Sub Service Type</div>
                          </th>
                        </tr>
                      </thead>
                      {each?.unsubscribedServiceList &&
                        each?.unsubscribedServiceList.length > 0 &&
                        each?.unsubscribedServiceList.map((subService, index) => {
                          return (
                            <tbody className="recFormat-body" style={{width: '100%'}} key={index}>
                              <tr
                                style={{
                                  backgroundColor: subService?.isCurrentRate ? '#90ee90' : '',
                                }}
                              >
                                <td>
                                  <div className="d-flex flex-row justify-content-center align-items-center">
                                    <IconButton
                                      style={{
                                        opacity: !roleData?.window?.['Client Maintenance']?.CG
                                          ?.edit ?
                                          0.3 :
                                          1,
                                      }}
                                      disabled={!roleData?.window?.['Client Maintenance']?.CG?.edit}
                                      onClick={() => {
                                        setShowSubscribePopup(true);
                                        setUnsubscribeRowData({
                                          ...subService,
                                          unsubscribedOrInactive: 'Unsubscribe',
                                        });
                                      }}
                                      className="client-search-icons mr-2"
                                    >
                                      <Tooltip title="Edit"><EditOutlinedIcon /></Tooltip>
                                    </IconButton>
                                  </div>
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.serviceType}
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.subServiceType}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                    </table>
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </AccordionDetails>
      </Accordion>
    );
  };

  const inactiveAccordian = () => {
    return (
      <Accordion
        className={`justify-content-center ${classes.root}`}
        onChange={(e, expanded) => {
          if (expanded) {
            let payLoad1 = {
              clientName: rowData.clientName,
              parentClientName: rowData.parentClientName,
            };
            dispatch(fetchSubscribedAndInactiveServices(payLoad1));
            payLoad1 = {};
          }
        }}
      >
        <AccordionSummary
          expandIcon={<ChevronRight className="mr-2" />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{maxHeight: '30px !important'}}
        >
          <Typography style={{fontWeight: 'bold'}}>Inactive services</Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{display: 'inherit', overflow: 'hidden'}}
          className={`mui-custom-table-container  p-0`}
        >
          {subscribedAndInactiveData?.inActiveSubscribedServices &&
            subscribedAndInactiveData?.inActiveSubscribedServices?.length > 0 ? (
              subscribedAndInactiveData?.inActiveSubscribedServices.map((each, index) => {
                return (
                  <Accordion
                    style={{width: '100%', marginTop: '0px'}}
                    className="custom-window-accordion "
                    key={index}
                  >
                    <AccordionSummary
                      expandIcon={<ChevronRight className="mr-2" />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography style={{fontWeight: 'bold'}}>{each?.companyType}</Typography>
                    </AccordionSummary>

                    <AccordionDetails className="p-0" style={{overflow: 'hidden'}}>
                      <table style={{width: '100%'}}>
                        <thead className="recFormat-header-container" style={{width: '100%'}}>
                          <tr>
                            <th style={{textAlign: 'center'}}>Actions</th>
                            <th style={{textAlign: 'left'}}>Client Code</th>
                            <th style={{textAlign: 'left'}}>Service Type</th>
                            <th>
                              <div style={{textAlign: 'left', maxWidth: '200px', wordWrap: 'normal'}}>Sub Service Type</div>
                            </th>
                            <th style={{textAlign: 'left'}}>Rate Type</th>
                            <th style={{textAlign: 'right'}}>Value</th>
                            <th style={{textAlign: 'left'}}>Start Date</th>
                            <th style={{textAlign: 'left'}}>End Date</th>
                            <th style={{textAlign: 'left'}}>Debtor Over Payments Remitted</th>
                            <th style={{textAlign: 'left'}}>Inflation Agreement</th>
                            <th style={{textAlign: 'left'}}>Postage Agreement</th>
                            <th style={{textAlign: 'left'}}>Rate Notes</th>
                          </tr>
                        </thead>
                        {each?.subServiceTypeListResponses &&
                        each?.subServiceTypeListResponses.length > 0 &&
                        each?.subServiceTypeListResponses.map((subService, index) => {
                          return (
                            <tbody className="recFormat-body" style={{width: '100%'}} key={index}>
                              <tr
                                style={{
                                  backgroundColor: subService?.isCurrentRate ? '#90ee90' : '',
                                }}
                              >
                                <td>
                                  <div className="d-flex flex-row justify-content-center align-items-center">
                                    <IconButton
                                      style={{
                                        opacity: !roleData?.window?.['Client Maintenance']?.CG
                                          ?.edit ?
                                          0.3 :
                                          1,
                                      }}
                                      disabled={!roleData?.window?.['Client Maintenance']?.CG?.edit}
                                      onClick={() => {
                                        setShowSubscribePopup(true);
                                        setUnsubscribeRowData({
                                          ...subService,
                                          unsubscribedOrInactive: 'Inactive',
                                        });
                                      }}
                                      className="client-search-icons mr-2"
                                    >
                                      <Tooltip title="Edit"><EditOutlinedIcon /></Tooltip>
                                    </IconButton>
                                    <Tooltip title="History"><HistoryIcon
                                      onClick={() => handleHistory(subService)}
                                      className="client-search-icons"
                                    /></Tooltip>
                                  </div>
                                </td>
                                <td className={classes.link}>
                                  {subService?.clientNumber}
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.serviceType}
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.subServiceType}
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {subService?.feeType[0].toUpperCase() +
                                    subService?.feeType.substring(1) === 'Flat' ? 'Flat Fee ' : subService?.feeType[0].toUpperCase() +
                                    subService?.feeType.substring(1)}
                                </td>
                                <td style={{textAlign: 'right'}}>
                                  {getfeeValue(
                                    subService?.feeValue.toFixed(2),
                                    subService?.feeType,
                                  )}
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {
                                    <div>
                                      {subService?.serviceStartDt !== null ?
                                        moment(subService.serviceStartDt).format('MM/DD/YYYY') :
                                        ''}
                                    </div>
                                  }
                                </td>
                                <td style={{textAlign: 'left'}}>
                                  {
                                    <div>
                                      {subService?.serviceEndDt !== null ?
                                        moment(subService.serviceEndDt).format('MM/DD/YYYY') :
                                        ''}
                                    </div>
                                  }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.paymentsRemitted ? subService?.paymentsRemitted === 'send' ? 'Send' : 'Don\'t Send' : '' }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.inflationAgreement ? subService?.inflationAgreement : '' }
                                </td>
                                <td style={{textAlign: 'left', minWidth: '200px'}}>
                                  {subService?.postageAgreement ? subService?.postageAgreement : '' }
                                </td>
                                <td
                                  style={{
                                    textAlign: 'left',
                                    maxWidth: '150px',
                                    overflowWrap: 'break-word',
                                  }}
                                >
                                  {subService?.rateNotes ? <MouseOverPopover
                                    data={subService?.rateNotes}
                                    popOverData={subService?.rateNotes}
                                    codeLength={subService?.rateNotes?.length}
                                  /> : '-'}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Typography className="text-center font-weight-bold mt-1 p-2">
              No records to display
              </Typography>
            )}
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <>
      <div className="">
        {subscribedAccordian()}
      </div>
      <div className="">
        {unsubscribedAccordian()}
      </div>
      <div className="">
        {inactiveAccordian()}
      </div>
      {/* current popup */}
      <DialogBox
        open={editSubServiceDialog}
        title="Edit Rate"
        maxWidth={'md'}
        dialogClose={handleSubServiceDialog}
      >
        <EditSubServiceTypeDialog
          rowData={rowData1}
          parentRowData={parentRowData}
          clientNumber={'clientNumber'}
          prePopData={prePopData}
          handleSubServiceDialog={handleSubServiceDialog}
          setEditSubServiceDialog={setEditSubServiceDialog}
          futureEffeciveValidationArr={futureEffeciveValidationArr}
          subscribedAndInactiveData={subscribedAndInactiveData}
        />
      </DialogBox>
      {/* future popup */}
      {/* <DialogBox
        open={editSubServiceDialogFuture}
        title="Edit Rate"
        maxWidth={"md"}
        dialogClose={handleSubServiceDialogFuture}
      >
        <EditSubServiceTypeDialogFuture
          rowData={rowData1}
          parentRowData={parentRowData}
          prePopData={prePopData}
          clientNumber={"clientNumber"}
          handleSubServiceDialog={handleSubServiceDialogFuture}
          setEditSubServiceDialog={setEditSubServiceDialogFuture}
          futureEffeciveValidationArr={futureEffeciveValidationArr}

        />
      </DialogBox> */}
      <DialogBox
        open={historyDialog}
        title="History"
        maxWidth={'xl'}
        dialogClose={handleHistoryDialog}
      >
        <HistoryDialog rowData={rowDataHistory} />
      </DialogBox>
      {/* subscribe popup or edit pop up for unsubscribe and inactive */}
      <DialogBox
        open={showSubscribePopup}
        title="Subscribe"
        maxWidth={'md'}
        dialogClose={handleSubscribePopup}
      >
        <SubscribeServicePopup
          rowData={unsubscribeRowData}
          parentRowData={parentRowData}
          clientNumber={'clientNumber'}
          handleSubServiceDialog={handleSubscribePopup}
          setEditSubServiceDialog={setShowSubscribePopup}
        />
      </DialogBox>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialogDelete}
        title="Delete Rate"
        value={`Are you sure you want to delete this Rate?`}
        handleSubmit={handleDeleteSubmit}
      />
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {errorMsg2 && <ErrorSnackbar errorMsg={errorMsg2} />}
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {successMsg2 && <SuccessSnackbar successMsg={successMsg2} />}
    </>
  );
}

export default DetailPanel;
